import endpoints from '../../api/endpoints';
import { useQuery } from '../../hooks/useApi';
import LoadingBlock from '../../components/LoadingBlock';
import ErrorAlert from '../../components/ErrorAlert';
import PageHeader from '../../components/PageHeader';
import { UserOutlined } from '@ant-design/icons';
import UserDetailsPanel from './UserDetailsPanel';
import useAuth from '../../hooks/useAuth';

// Stage 5K-5B / 5L: thin wrapper that renders the inline UserDetailsPanel
// for the currently logged-in user. Reachable to masters and sub-users
// alike via /profile. Lifecycle handlers (lock/surrender) are
// intentionally NOT passed — a user cannot lock or surrender their own
// account.
export default function MyProfilePage() {
  const { me, refreshMe } = useAuth();

  const profileQ = useQuery(() => endpoints.users.getMyProfile(), []);

  const user = profileQ.data;

  return (
    <div>
      <PageHeader
        title="My profile"
        subtitle="Your contact details, security settings, and recent activity."
        icon={<UserOutlined />}
      />
      <ErrorAlert error={profileQ.error} />
      {profileQ.loading || !user ? (
        <LoadingBlock />
      ) : (
        <UserDetailsPanel
          user={user}
          currentUserId={me ? me.userId || me.id || user.id : user.id}
          onChanged={() => {
            profileQ.refetch();
            refreshMe();
          }}
          // No lifecycle handlers — you can't lock/surrender yourself.
        />
      )}
    </div>
  );
}
